import type { PublicCourseTerm } from "../CourseTerm.js";

export function isTermFull(term: PublicCourseTerm): boolean {
	return term.participantsCount >= term.capacity;
}
